var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"stroke":"#161922","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M2.667 4.668v-2h10.667v2M6 13.335h4M8 2.668v10.667"}})])
}
var staticRenderFns = []

export default { render: render }